import script from "./Users.vue?vue&type=script&setup=true&lang=js"
export * from "./Users.vue?vue&type=script&setup=true&lang=js"

import "./Users.vue?vue&type=style&index=0&id=34464fce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34464fce"]])

export default __exports__